 <!--  Scene Types -->
    <p-fieldset legend="Scene Types Management" [toggleable]="true" [collapsed]="true">
      <div class="card">
        <p-toolbar styleClass="p-mb-4">
          <ng-template pTemplate="left">
            <button pButton pRipple 
              label="Manage Scene Types Management" 
              icon="pi pi-external-link" 
              class="p-button-outlined"
              (click)="navigateToSceneTypes()">
            </button>
          </ng-template>
        </p-toolbar>
      </div>
    </p-fieldset>
  
    <!-- Entity Settings -->
    <p-fieldset legend="Entity Types" [toggleable]="true" styleClass="p-my-3" [collapsed]="true">
      <div class="card">
        <p-toolbar styleClass="p-mb-4">
          <ng-template pTemplate="left">
            <button pButton pRipple 
              label="Manage Entity Types" 
              icon="pi pi-external-link" 
              class="p-button-outlined"
              (click)="navigateToEntityTypes()">
            </button>
          </ng-template>
        </p-toolbar>
      </div>
    </p-fieldset>
    <!-- Imagery Settings  -->
    <p-fieldset legend="Asset Types" [toggleable]="true" styleClass="p-my-3" [collapsed]="true">
      <div class="card">
        <p-toolbar styleClass="p-mb-4">
          <ng-template pTemplate="left">
            <button pButton pRipple 
              label="Manage Asset Types" 
              icon="pi pi-external-link" 
              class="p-button-outlined"
              (click)="navigateToImagerySettings()">
            </button>
          </ng-template>
        </p-toolbar>
      </div>
    </p-fieldset>
    <!-- Links & Destinations -->
    <p-fieldset legend="Links & Destinations" [toggleable]="true" styleClass="p-my-3" [collapsed]="true">
      <div class="card">
        <p-toolbar styleClass="p-mb-4">
          <ng-template pTemplate="left">
            <button pButton pRipple 
              label="Manage Links & Destinations" 
              icon="pi pi-external-link" 
              class="p-button-outlined"
              (click)="navigateToLinkDestination()">
            </button>
          </ng-template>
        </p-toolbar>
      </div>
    </p-fieldset>
    <!-- Tags -->
    <p-fieldset legend="Tags" [toggleable]="true" styleClass="p-my-3" [collapsed]="true">
    <div class="card">
      <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
          <button pButton pRipple 
            label="Manage Tags" 
            icon="pi pi-external-link" 
            class="p-button-outlined"
            (click)="navigateToTags()">
          </button>
        </ng-template>
      </p-toolbar>
    </div>
    </p-fieldset>

    <!-- Content Hold -->
    <!-- <content-hold-managed-list></content-hold-managed-list> -->
    <p-fieldset legend="Content Hold" [toggleable]="true" styleClass="p-my-3" [collapsed]="true">
    <div class="card">
      <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
          <button pButton pRipple 
            label="Manage Content Hold" 
            icon="pi pi-external-link" 
            class="p-button-outlined"
            (click)="navigateToContentHold()">
          </button>
        </ng-template>
      </p-toolbar>
    </div>  
    </p-fieldset>
    <!-- Challenges Content Hold -->
    <p-fieldset legend="Challenges Content Hold" [toggleable]="true" styleClass="p-my-3" [collapsed]="true">
    <div class="card">
      <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
          <button pButton pRipple 
            label="Manage Challenges Content Hold" 
            icon="pi pi-external-link" 
            class="p-button-outlined"
            (click)="navigateToChallengesContentHold()">
          </button>
        </ng-template>
      </p-toolbar>
    </div>
    </p-fieldset>
    <!-- <challenge-content-hold-managed-list></challenge-content-hold-managed-list> -->
